import { combineReducers } from "redux";
import { casesReducer } from "./casesReducer";
import { userReducer } from "./userReducer";
import { searchReducer } from "./searchReducer";
import { getFeed } from "./feedReducer";
import { interviewReducer } from "./interviewReducer";
import { customerReducer } from "./customerReducer";
import { childFacilitiesReducer } from "./childFacilitiesReducer";
import { pdfReducer } from "./pdfReducer";
import { pdfForCustomerReducer } from "./pdfForSpecificCustomerReducer";
import { programReducer } from "./programReducer";
import { selectedProgramsReducer } from "./selectedProgramReducer";
import { lookupReducer } from "./lookupReducer";
import { statesReducer } from "./statesReducer";
import { caseCountReducer } from "./caseCountReducer";
import { householdReducer } from "./householdReducer";
import { countiesReducer } from "./countiesReducer";
import { documentsReducer } from "./documentsReducer";
import { personReducer } from "./personReducer";
import { notesReducer } from "./notesReducer";
import { callCenterReducer } from "./callCenterlReducer";
import { assistanceCategoriesReducer } from "./assistanceCategoriesReducer";
import { householdsReducer } from "./householdsReducer";
import { faDocumentationReducer } from "./faDocumentationReducer";
import { patientDataReducer } from "./patientDataReducer";
import { patientFindingsReducer } from "./patientFindingsReducer";
import { patientsReducer } from "./patientsReducer";
import { retrocheckFilesReducer } from "./retrocheckFilesReducer";
import { retrocheckBillingFileRecordsReducer } from "./retrocheckBillingFileRecordsReducer";
import { selectedCustomerReducer } from "./selectedCustomerReducer";
import { retrocheckFileInfoReducer } from "./retrocheckFileInfoReducer";
import { retrocheckFileRecordsReducer } from "./retrocheckFileRecordsReducer";
import { retrocheckFileSummaryReducer } from "./retrocheckFileSummaryReducer";
import { caseCluesReducer } from "./caseCluesReducer";
import { customerProgramsReducer } from "./customerProgramsReducer";
import { notificationsReducer } from "./notificationsReducer";

export const reducers = combineReducers({
    cases: casesReducer,
    user: userReducer,
    feed: getFeed,
    caseClues: caseCluesReducer,
    searchResults: searchReducer,
    originalCustomer: customerReducer,
    customer: selectedCustomerReducer,
    childFacilities: childFacilitiesReducer,
    interview: interviewReducer,
    household: householdReducer,
    households: householdsReducer,
    pdfs: pdfReducer,
    pdfsForCustomer: pdfForCustomerReducer,
    programs: programReducer,
    selectedPrograms: selectedProgramsReducer,
    interviewLookups: lookupReducer,
    states: statesReducer,
    caseCounts: caseCountReducer,
    counties: countiesReducer,
    documents: documentsReducer,
    person: personReducer,
    notes: notesReducer,
    callCenter: callCenterReducer,
    assistanceCategories: assistanceCategoriesReducer,
    faDocumentation: faDocumentationReducer,
    patientData: patientDataReducer,
    patientFindings: patientFindingsReducer,
    retrocheckPatients: patientsReducer,
    retrocheckFiles: retrocheckFilesReducer,
    retrocheckBillingFiles: retrocheckBillingFileRecordsReducer,
    retrocheckFileInfo: retrocheckFileInfoReducer,
    retrocheckFileRecords: retrocheckFileRecordsReducer,
    retrocheckFileSummary: retrocheckFileSummaryReducer,
    customerPrograms: customerProgramsReducer,
    notifications: notificationsReducer,
});
